import { combineReducers } from 'redux';

import auth from './auth';
import cart from './cart';
import theme from './theme';
import home from './home';
const rootReducer = combineReducers({ home, auth, cart, theme });

export default rootReducer;